import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { StyleSheet, css } from '@coursera/coursera-ui';

import type { InformationCardProps } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';
import InformationCard from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';
import InformationCardBody from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCardBody';
import { TabCaption } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/typography';

import _t from 'i18n!nls/program-skills-objectives';

const styles = StyleSheet.create({
  root: {
    padding: '24px 14px',
    margin: '24px 0 0 0',
  },

  section: {
    width: '50%',
  },
});

const AboutAddingSkillSetsInformationCard: React.FC<InformationCardProps> = (props) => (
  <InformationCard {...props} rootClassName={css(styles.root, props.rootClassName).className}>
    <InformationCardBody>
      <section {...css(styles.section)}>
        <TabCaption>{_t('About adding SkillSets to a program')}</TabCaption>
        <Typography2 component="p" variant="bodyPrimary">
          {_t(
            'Start by browsing Coursera’s bank of SkillSets and adding the ones best suited to your learning goals into your program. SkillSets provide learners with proficiency targets, and dynamic content recommendations to help them acheive these goals.'
          )}
        </Typography2>
      </section>
    </InformationCardBody>
  </InformationCard>
);

export default AboutAddingSkillSetsInformationCard;
